import { InjectionToken } from '@angular/core';

import { Observable } from 'rxjs';

import { createProviderToken } from '@core/common-legacy';

import { Colors as DarkTheme } from './core/tokens/theme/dark/ts/colors';
import { Colors as LightTheme } from './core/tokens/theme/light/ts/colors';

export const SupportedThemes = { light: LightTheme, dark: DarkTheme };

export type SupportedThemesT = keyof typeof SupportedThemes;
export type Theme = (typeof SupportedThemes)[SupportedThemesT];
export type ThemeName = SupportedThemesT | 'auto';

export const RECRUITEE_THEME_LS_KEY = 'recruitee-theme';
export const RECRUITEE_THEME_MIGRATED_LS_KEY = 'recruitee-theme-migrated';
export const RECRUITEE_THEME_DEFAULT = 'light';

type BackgroundSpecificTokenExtract<T> = Extract<T, `colorBg${string}`>;
export type BackgroundToken = BackgroundSpecificTokenExtract<keyof Theme>;

type EffectiveTheme = { effectiveThemeName$: Observable<SupportedThemesT> };

export const EffectiveTheme = new InjectionToken<EffectiveTheme>(
  'effectiveThemeName$ with dark or light string',
);

export const { provide: providerEffectiveThemeFactory, inject: injectEffectiveThemeFactory } =
  createProviderToken<EffectiveTheme>('effectiveThemeName$ with dark or light string')();
